import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";
import useRequest from "@/lib/request/useRequest";
import { Button, DatePicker } from "@heroui/react";
import {
    DateValue,
    getLocalTimeZone,
    parseDate,
} from "@internationalized/date";
import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function AnalyzeImagery() {
    const { fieldId } = useFieldDashboard() ?? {};

    const { t } = useTranslation("insights");

    const { useMutateRequest } = useRequest();
    const mutate = useMutateRequest({
        errorMessage: t("messages.failedToAnalyzeImagery"),
        successMessage:
            t("messages.imageAnalysisStarted"),
    });

    const [startDate, setStartDate] = useState<DateValue | null>(
        parseDate(dayjs().subtract(1, "w").format("YYYY-MM-DD")),
    );
    const [endDate, setEndDate] = useState<DateValue | null>(
        parseDate(dayjs().format("YYYY-MM-DD")),
    );

    const onAnalyze = () => {
        mutate.mutate({
            url: `fields/${fieldId}/reanalyze_imagery/`,
            method: "put",
            params: {
                start_date: dayjs(startDate?.toDate(getLocalTimeZone())).format(
                    "YYYY-MM-DD",
                ),
                end_date: dayjs(endDate?.toDate(getLocalTimeZone())).format(
                    "YYYY-MM-DD",
                ),
            },
        });
    };

    return (
        <div className="flex flex-col gap-2">
            <span className="font-semibold">{t("reAnalyzeImagery")}</span>
            <div className="flex gap-2">
                <DatePicker
                    label={t("startDate")}
                    size="sm"
                    value={startDate}
                    onChange={setStartDate}
                />
                <DatePicker
                    label={t("endDate")}
                    size="sm"
                    value={endDate}
                    onChange={setEndDate}
                />
            </div>
            <Button
                size="sm"
                color="primary"
                onPress={onAnalyze}
                isDisabled={!startDate || !endDate || mutate.isPending}
                isLoading={mutate.isPending}
            >
                {t("analyze")}
            </Button>
        </div>
    );
}

export default AnalyzeImagery;
